// assets
import { IconTypography, IconPalette, IconShadow, IconWindmill } from '@tabler/icons';

// constant
const icons = {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const projects = {
    id: 'projects',
    title: 'Projects',
    type: 'group',
    children: [
        {
            id: 'Erlich',
            title: 'Erlich',
            type: 'collapse',
            url: '/page1',
            icon: icons.IconPalette,
            children: [
                {
                    id: 'Tread',
                    title: 'Tread',
                    type: 'item',
                    url: '/tread-erlich',
                    breadcrumbs: false
                },
                {
                    id: 'Bike+',
                    title: 'Bike+',
                    type: 'item',
                    url: '/bikeplus-erlich',
                    breadcrumbs: false
                },
                {
                    id: 'Row',
                    title: 'Row',
                    type: 'item',
                    url: '/caesar-erlich',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'Passerine',
            title: 'Passerine',
            type: 'collapse',
            icon: icons.IconWindmill,
            children: [
                {
                    id: 'stable_builds',
                    title: 'Stable Builds',
                    type: 'item',
                    url: '/stable-builds',
                    breadcrumbs: false
                },
                {
                    id: 'test_queue',
                    title: 'Test Queue',
                    type: 'item',
                    url: '/test-queue',
                    breadcrumbs: false
                },
                {
                    id: 'test_combination',
                    title: 'Combinations',
                    type: 'item',
                    url: '/test-combinations',
                    breadcrumbs: false
                },
                {
                    id: 'swallow_settings',
                    title: 'Swallow IP',
                    type: 'item',
                    url: '/swallow-settings',
                    breadcrumbs: false
                },
                {
                    id: 'add_swallow_settings',
                    title: 'Add IP',
                    type: 'item',
                    url: '/swallow-add-settings',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'Automation',
            title: 'Siraya',
            type: 'collapse',
            icon: icons.IconWindmill,
            children: [
                {
                    id: 'Auto_report_filter',
                    title: 'Key Filter',
                    type: 'item',
                    url: '/test-filter',
                    breadcrumbs: false
                },
                {
                    id: 'Amber_external',
                    title: 'Build Filter',
                    type: 'item',
                    url: '/amber-external',
                    breadcrumbs: false
                },
                {
                    id: 'Performance',
                    title: 'Performance',
                    type: 'item',
                    url: '/performance',
                    breadcrumbs: false
                },
                {
                    id: 'Performance_History',
                    title: 'Performance History',
                    type: 'item',
                    url: '/performance-history',
                    breadcrumbs: false
                },
                {
                    id: 'Performance_Raw',
                    title: 'Performance Raw',
                    type: 'item',
                    url: '/performance-raw-data',
                    breadcrumbs: false
                },
                {
                    id: 'Test_Item',
                    title: 'Error Query',
                    type: 'item',
                    url: '/error-query',
                    breadcrumbs: false
                },
                {
                    id: 'Ignore_Report',
                    title: 'Ignore Report',
                    type: 'item',
                    url: '/ignore-report',
                    breadcrumbs: false
                },
                {
                    id: 'Automation_adv',
                    title: 'Advanced',
                    type: 'collapse',
                    children: [
                        {
                            id: 'Auto_report',
                            title: 'Text Filter',
                            type: 'item',
                            url: '/test-automation',
                            breadcrumbs: false
                        },
                        {
                            id: 'Image_selection',
                            title: 'OOBE Test',
                            type: 'item',
                            url: '/image-selection',
                            breadcrumbs: false
                        }
                    ]
                }
            ]
        },
        {
            id: 'Nestling',
            title: 'Nestling',
            type: 'collapse',
            icon: icons.IconWindmill,
            children: [
                {
                    id: 'nestling_upload',
                    title: 'Nestling Upload',
                    type: 'item',
                    url: '/nestling-upload',
                    breadcrumbs: false
                },
                {
                    id: 'nestling_queue',
                    title: 'Nestling Queue',
                    type: 'item',
                    url: '/nestling-queue',
                    breadcrumbs: false
                },
                {
                    id: 'nestling_plus',
                    title: 'Nestling+',
                    type: 'item',
                    url: '/nestling-plus',
                    breadcrumbs: false
                },
                {
                    id: 'nestling_plus_queue',
                    title: 'Nestling+ Queue',
                    type: 'item',
                    url: '/nestling-plus-items',
                    breadcrumbs: false
                },
            ]
        },
        {
            id: 'Tiger',
            title: 'Tiger',
            type: 'collapse',
            icon: icons.IconWindmill,
            children: [
                {
                    id: 'tiger_voice_queue',
                    title: 'VTool Queue',
                    type: 'item',
                    url: '/voice-tests',
                    breadcrumbs: false
                },
                {
                    id: 'tiger_voice_test',
                    title: 'VTool Test History',
                    type: 'item',
                    url: '/query-voice',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'Self_Diagnostic',
            title: 'Self Diag.',
            type: 'collapse',
            children: [
                {
                    id: 'bbro',
                    title: 'B+Bro',
                    type: 'item',
                    url: '/bplus-bro',
                    breadcrumbs: false
                },
                {
                    id: 'Testrail_cases',
                    title: 'Testrail Summarize',
                    type: 'item',
                    url: '/testrail-case',
                    breadcrumbs: false
                },
                {
                    id: 'Automated_cases',
                    title: 'SYS. App Automated',
                    type: 'item',
                    url: '/testrail-automated',
                    breadcrumbs: false
                },
                {
                    id: 'Other_Automated_cases',
                    title: 'Other Automated',
                    type: 'item',
                    url: '/testrail-other-automated',
                    breadcrumbs: false
                },
                {
                    id: 'CFX_App_Automated',
                    title: 'CFX App Automated',
                    type: 'item',
                    url: '/cfx-app-automated',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'Users',
            title: 'Admin',
            type: 'collapse',
            icon: icons.IconWindmill,
            children: [
                {
                    id: 'limit_list',
                    title: 'S3 buckets list',
                    type: 'item',
                    url: '/file-limit',
                    breadcrumbs: false
                },
                {
                    id: 'add_limits',
                    title: 'S3 buckets config',
                    type: 'item',
                    url: '/add-file-limit',
                    breadcrumbs: false
                },
                {
                    id: 'user_list',
                    title: 'User List',
                    type: 'item',
                    url: '/user-list',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default projects;
